module.exports = __webpack_public_path__ + "img/icontubiaoku-25.78731793.png";